<template>
  <address
    class="contacts-address"
    itemprop="address"
    itemscope itemtype="http://schema.org/PostalAddress"
  >
    <span itemprop="postalCode">{{ postalCode }}</span>
    {{ countryType }} <span itemprop="addressCountry">{{ country }}</span>
    <br>
    г. <span itemprop="addressLocality">{{ city }}</span>,
    ул. <span itemprop="streetAddress">{{ street }} {{ houseNumber }}</span>
  </address>
</template>

<script>
export default {
  name: 'ContactsAddress',
  data: function () {
    return {
      postalCode: 224033,
      country: 'Беларусь',
      countryType: 'Республика',
      city: 'Брест',
      street: 'Cябровская',
      houseNumber: '51"А"'
    }
  }
}
</script>

<style scoped lang="scss">
  .contacts-address {
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsAddress.vue